import React from "react";
import { Button } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { useHoldStatus } from "./useHoldStatus";

export interface HoldStatusProps {
  hold: HostSystemItemView;
  onClickSuspend: () => void;
  showChangeButton?: boolean; // hide for student view
}

export const HoldStatus: React.FC<HoldStatusProps> = ({
  hold,
  onClickSuspend,
  showChangeButton = true,
}) => {
  const { translate } = useLanguage();
  const { getHoldStatusData } = useHoldStatus();
  const data = getHoldStatusData(hold);

  if (!data) return <span className="holdStatus" />;

  return (
    <span className="holdStatus">
      {data.isSuspended ? (
        <>
          <span>{data.statusLabel}:</span>{" "}
          <strong className={data.statusClassName}>{data.statusValue}</strong>{" "}
          <span className={data.untilClassName}>{data.untilLabel}:</span>{" "}
          <strong className={data.untilClassName}>
            {data.untilValue}
            {showChangeButton && (
              <Button onClick={onClickSuspend}>({translate("change")})</Button>
            )}
          </strong>
        </>
      ) : (
        <>
          {data.statusLabel}:{" "}
          <span className={data.statusClassName}>{data.statusValue}</span>
        </>
      )}
    </span>
  );
};
